import Badge from "@mui/material/Badge"

export default function MuiBadge({
    children,
    badgeContent
}) {
    return (
        <Badge
            badgeContent={ badgeContent }
            sx={ {
                "& .MuiBadge-badge": {
                    color: "white",
                    backgroundColor: "#CB3C3C"
                }
            } }
        >
            { children }
        </Badge>
    )
}
